import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    error: '',
    created: null,
    violations: null
  },
  getters: {
    error: (state) => state.error,
    isLoading: (state) => state.isLoading,
    created: (state) => state.created,
    violations: (state) => state.violations
  },
  mutations: {
    setError (state, error) {
      state.error = error
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setCreated (state, created) {
      state.created = created
    },
    setViolations (state, violations) {
      state.violations = violations
    },
    reset (state) {
      state.created = null
      state.error = ''
      state.isLoading = false
      state.violations = null
    }
  },
  actions: {
    async create ({ commit }, data) {
      commit('toggleLoading')
      const response = await new ApiService('e_x_s_b_invoices').post(data)
      commit('setCreated', await response.json())
      commit('toggleLoading')
    },
    reset ({ commit }) {
      commit('reset')
    }
  }
}
